import React, { SyntheticEvent, useEffect, useState } from 'react';
import './grafik.scss';
import appInfo from '../../configs/app-info';

import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Grid, { GridProps } from '@mui/material/Grid';
import { styled, useTheme } from '@mui/material/styles'
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import { useAuth } from "../../contexts/AuthContext";

import { useNavigate, useSearchParams } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import MsiPieChart from '../../components/custom/MsiPieChart';
import MsiChart from '../../components/custom/MsiChart';

import { complaintsData } from '../../sample-data/example-chart';
import { splineData, seriesTypeLabel } from "../../sample-data/example-spline";
import MsiSplineChart from '../../components/custom/MsiSplineChart';
import Swal from 'sweetalert2';

// ** Third Party Imports
import axios from 'axios'
import apiUrl from '../../configs/constant';

import Tab from '@mui/material/Tab'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'
import MuiTabList, { TabListProps } from '@mui/lab/TabList'
import TabList from '@mui/lab/TabList';
import OrgStructure from '../../components/chart/organization-structure';


// Styled Grid component
const StyledGrid = styled(Grid)<GridProps>(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        order: -1,
        display: 'flex',
        justifyContent: 'center'
    }
}))

// Styled component for the image
const Img = styled('img')(({ theme }) => ({
    right: 10,
    bottom: 8,
    width: 150,
    position: 'absolute',
    [theme.breakpoints.down('sm')]: {
        width: 250,
        position: 'static'
    }
}))


const divStyle = {
    overflowX: 'visible' as const,
    overflowY: 'scroll' as const,
    position: 'relative' as const
}

export default function Home() {
    const navigate = useNavigate();
    const userData = JSON.parse(localStorage.getItem('user')!)
    const user = userData.data.userLoginResponse
    const token = userData.data.token

    const cabang = localStorage.getItem('cabang')

    const dataSource = [{
        label: 'USA',
        value: 110,
    }, {
        label: 'China',
        value: 100,
    }, {
        label: 'Russia',
        value: 72,
    }, {
        label: 'Britain',
        value: 47,
    }, {
        label: 'Australia',
        value: 46,
    }, {
        label: 'Germany',
        value: 41,
    }, {
        label: 'France',
        value: 40,
    }, {
        label: 'Indonesia',
        value: 50,
    }];

    const [searchParams, setSearchParams] = useSearchParams();
    const activeTab = searchParams.get("tab") || "1"; // Default ke tab 1

    const [filteredData, setFilteredData] = useState<any[]>([])
    const [listData, setListData] = useState<any[]>([])
    const [searchText, setSearchText] = useState<string>('')

    const [value, setValue] = useState<string>('1')
    const [listDivisi, setListDivisi] = useState<any[]>([])
    const [listDivisiPerson, setListDivisiPerson] = useState<any[]>([])
    const [listJabatan, setListJabatan] = useState<any[]>([])
    const [arrLead, setArrLead] = useState<any[]>([])
    const [listPerson, setListPerson] = useState<any>([])
    const [budget, setBudget] = useState<string>('1')

    useEffect(() => {
        // Swal.fire({
        //   title: 'Now loading',
        //   allowEscapeKey: false,
        //   allowOutsideClick: false,
        //   didOpen: () => {
        //     Swal.showLoading()
        //   }
        // })

        // const getDivisi = async () => {
        //   let url = apiUrl.apiUrl + '/api/hr/divisi/list-divisi?cabang_id=1&parent_id=3'

        //   await axios
        //     .get(url, {
        //       headers: {
        //         Authorization: 'Bearer ' + storedToken
        //       }
        //     })
        //     .then(response => {
        //       if (response.data.success) {
        //         const data = response.data.data
        //         setListDivisi(data)
        //         Swal.close()
        //       }
        //     })
        //     .catch(function (error) {
        //       console.log(error)
        //     })
        // }

        // const getDataAll = () => {
        //   let url = apiUrl.apiUrl + '/api/hr/divisi/list-divisi-person?divisi_id=3'
        //   axios
        //     .get(url, {
        //       headers: {
        //         Authorization: 'Bearer ' + storedToken
        //       }
        //     })
        //     .then(response => {
        //       const data = response.data.data
        //       const budget = response.data.budget[0].budget
        //       setBudget(budget)
        //       setFilteredData(data)
        //       Swal.close()
        //     })
        // }

        // getDivisi()
        // getDataAll()
        // if (activeTab == null) {
        //   setValue('1')
        // } else {
        //   setValue(activeTab)
        //   getDivisiPerson(activeTab)
        // }

    }, [])

    // const getDivisiPerson = async (param: string) => {
    //   let url = apiUrl.apiUrl + '/api/hr/divisi/list-divisi-person?divisi_id=' + param

    //   await axios
    //     .get(url, {
    //       headers: {
    //         Authorization: 'Bearer ' + storedToken
    //       }
    //     })
    //     .then(response => {
    //       if (response.data.success) {
    //         let data = response.data.data
    //         let budget = response.data.budget[0].budget
    //         setBudget(budget)
    //         let arrh: any[] = []
    //         let arrb: any[] = []
    //         let arrj: any[] = []

    //         // kepala dikeluarkan dahulu
    //         data.forEach((element: any, key: any) => {
    //           // console.log(element)
    //           if (element.nama == '') {
    //             element.nama = '\xa0\xa0\xa0\xa0\xa0\xa0\xa0'
    //           }
    //           if (element.hrjabatan_id == null) {
    //             arrh.push(element)
    //           } else {
    //             // buat card tiap jabatan
    //             arrb.push(element)
    //             if (element.id != null && !arrj.find(e => e.id === element.id)) {
    //               let objj = {
    //                 id: element.id,
    //                 nama_jabatan: element.nama_jabatan,
    //                 is_parent: element.is_parent,
    //                 parent_id: element.hrjabatan_id,
    //                 jumlah_aktual: element.jumlah_aktual,
    //                 jumlah_karyawan: element.jumlah_karyawan,
    //                 hrjabatan_id: element.hrjabatan_id,
    //                 budget_mingguan: element.budget_mingguan
    //               }
    //               arrj.push(objj)
    //             }
    //           }
    //         })
    //         setArrLead(arrh)
    //         setListDivisiPerson(arrb)
    //         setListJabatan(arrj)
    //         setListPerson(data)
    //       }
    //     })
    //     .catch(function (error) {
    //       console.log(error)
    //     })
    // }

    // const handleChange = (event: SyntheticEvent, newValue: string) => {
    //   setSearchParams({ tab: newValue });
    //   setValue(newValue)
    //   getDivisiPerson(newValue)
    // }

    return (
        <Grid container spacing={1}>
            <Grid item xs={12} sm={6}>
                <div className={'content-block dx-card responsive-paddings'} style={{ position: 'relative' }}>
                    <MsiPieChart data={dataSource} title='Pie Charts' />
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <div className={'content-block dx-card responsive-paddings'} style={{ position: 'relative' }}>
                    <MsiChart title='Chart' array={complaintsData} />
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <div className={'content-block dx-card responsive-paddings'} style={{ position: 'relative' }}>
                    <MsiSplineChart title='Spline Area' array={splineData} />
                </div>
            </Grid>
        </Grid>
    )
}

